import $ from 'jquery';

const MessageOutboundFactory = (NewBackendService, $q, $http, endPoints) => {
  'ngInject';

  const service = {
    getTemplateMessages: (userContext,bound_type,rich_type) => $q((resolve, reject) => {
      var walletId = userContext.business ? userContext.business.wallet.id : userContext.walletId
      NewBackendService.invokeWebApiPost(`${endPoints.crmLightUrl}/tinabaapp/api/merchants/${walletId}/messages/templates`, {
        bound_type: bound_type,
        rich_type: rich_type
      }).then((response) => {
        resolve(response.data)
      }, (reason) => {
        reject(reason);
      });
    }),
    getDefaultMessage: (userContext) => $q((resolve, reject) => {
      var walletId = userContext.business ? userContext.business.wallet.id : userContext.walletId
      NewBackendService.invokeWebApiGet(`${endPoints.crmLightUrl}/tinabaapp/api/merchants/${walletId}/messages/default-messages`, {}).then((response) => {
        resolve(response.data)
      }, (reason) => {
        reject(reason);
      });
    }),
    updateDefaultMessage: (userContext,messages) => $q((resolve, reject) => {
      var walletId = userContext.business ? userContext.business.wallet.id : userContext.walletId
      NewBackendService.invokeWebApiPost(`${endPoints.crmLightUrl}/tinabaapp/api/merchants/${walletId}/messages/default-messages`, messages).then((response) => {
        resolve(response.data)
      }, (reason) => {
        reject(reason);
      });
    }),
    getTargetPercentage: (userContext, target_object) => $q((resolve, reject) => {
      var walletId = userContext.business ? userContext.business.wallet.id : userContext.walletId
      NewBackendService.invokeWebApiPost(`${endPoints.crmLightUrl}/tinabaapp/api/merchants/${walletId}/messages/default-messages`, target_object).then((response) => {
        resolve(response.data)
      }, (reason) => {
        reject(reason);
      });
    }),
    saveCampaign: (userContext, campaign_object) => $q((resolve, reject) => {
      var walletId = userContext.business ? userContext.business.wallet.id : userContext.walletId
      NewBackendService.invokeWebApiPost(`${endPoints.crmLightUrl}/tinabaapp/api/merchants/${walletId}/campagne`, campaign_object).then((response) => {
        resolve(response.data)
      }, (reason) => {
        reject(reason);
      });
    }),
    getMessagesListing: (userContext, listing_mode) => $q((resolve, reject) => {
      var walletId = userContext.business ? userContext.business.wallet.id : userContext.walletId
      let url = `${endPoints.crmLightUrl}/tinabaapp/api/merchants/${walletId}/campagne`;
      
      if (listing_mode == 'history') {
        url = url + '/archiviate';
      }

      NewBackendService.invokeWebApiGet(url, {}).then((response) => {
        resolve(response.data)
      }, (reason) => {
        reject(reason);
      });
    }),
    deleteMessage: (userContext, message_id) => $q((resolve, reject) => {
      var walletId = userContext.business ? userContext.business.wallet.id : userContext.walletId
      NewBackendService.invokeWebApiDelete(`${endPoints.crmLightUrl}/tinabaapp/api/merchants/${walletId}/campagne/${message_id}`).then((response) => {
        resolve(response.data)
      }, (reason) => {
        reject(reason);
      });
    }),

  };

  return service;
};

export default MessageOutboundFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/messageOutbound.factory.js
 **/